<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Tareas</h3>
            </div>
            <div class="col-6 text-right">
              <base-button type="primary" icon size="sm" @click="addTipo()">
                <span class="btn-inner--icon"
                  ><i class="fas fa-user-edit"></i
                ></span>
                <span class="btn-inner--text">Añadir tarea</span>
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div>
              <form>
                <base-input
                  v-model="query"
                  type="search"
                  prepend-icon="fas fa-search"
                  placeholder="Buscar..."
                  clearable
                />
              </form>
            </div>
          </div>
          <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="revisiones"
            @sort-change="sortChange"
          >
            <div slot="empty" v-if="loading">
              <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>

            <el-table-column label="Fecha" prop="fecha" sortable="custom">
              <template slot-scope="{ row }">
                {{ moment(row.fecha).format("DD/MM/YYYY") }}
              </template>
            </el-table-column>

            <!--  <el-table-column
              label="Equipo"
              prop="activo.data.attributes.numero_serie_qr"
              sortable="custom"
            /> -->

            <el-table-column label="Empresa a revisar" sortable="custom">
              <template v-slot="{ row }">
                <b>{{ row.empresa.data.attributes.razonSocial }}</b>
              </template>
            </el-table-column>

            <el-table-column
              label="Estado de la tarea"
              prop="estado_tarea.data.attributes.nombre"
              sortable="custom"
            >
              <template slot-scope="{ row }">
                <span
                  class="badge badge-default"
                  :style="[
                    row.estado_tarea.data.attributes.nombre == 'Completada'
                      ? { backgroundColor: 'green' }
                      : { backgroundColor: 'orange' },
                  ]"
                  >{{ row.estado_tarea.data.attributes.nombre }}</span
                >
              </template>
            </el-table-column>

            <el-table-column label="Revisado por" sortable="custom">
              <template v-slot="{ row }">
                <img
                  :src="
                    row.revisor.data.attributes.imagen_perfil.data.attributes
                      .url
                  "
                  class="avatar rounded-circle mr-3"
                />
                <b>{{ row.revisor.data.attributes.username }}</b>
              </template>
            </el-table-column>

            <el-table-column align="center">
              <div slot-scope="{ row }" class="table-actions">
                <el-tooltip content="Editar" placement="top">
                  <a
                    type="text"
                    @click="editTipo(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-user-edit"></i>
                  </a>
                </el-tooltip>

                <el-tooltip content="Eliminar" placement="top">
                  <a
                    type="text"
                    @click="deleteTipo(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
              {{ total }} registros

              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{ selectedRows.length }} rows selected
              </span>
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "@/components/";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

export default {
  layout: "DashboardLayout",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      query: null,
      revisiones: [],
      selectedRows: [],
      sort: "createdAt:desc",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },

      total: 0,
      loading: true,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      var profile = this.$store.getters["profile/me"];
      console.log(profile);
      var empresas = [];
      profile.empresas.forEach((element) => {
        empresas.push(element.id);
      });
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        //activo.data.attributes.numero_serie_qr
        filters: {
          ...(this.query
            ? {
                revisor: {
                  empresas: {
                    id: { $in: empresas },
                  },
                },
                revisor: {
                  username: { $containsi: this.query },
                },
                //nombre: { $containsi: this.query },
              }
            : {
                revisor: {
                  empresas: {
                    id: { $in: empresas },
                  },
                },
              }),
        },
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("tareas/list", params).then(() => {
        this.revisiones = this.$store.getters["tareas/list"];
        console.log(this.revisiones);
        this.total = this.$store.getters["tareas/listTotal"];
      });
      this.loading = false;
    },

    async deleteTipo(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        this.$notify({
          type: "danger",
          message: "You are not allowed not change data of default empresa.",
        });
        return;
      }
      try {
        const confirmation = await swal.fire({
          title: `Eliminar esta tarea?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "No, mantenerla",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        if (confirmation.value === true) {
          await this.$store.dispatch("tareas/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: "Tarea eliminada correctamente.",
          });
        }
      } catch (error) {
        if (error.response.data.errors[0]) {
          this.$notify({
            type: "danger",
            message: "This Empresa still has associated Items.",
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
    addTipo() {
      this.$router.push({ name: "Add Tarea" });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit Tarea",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
  },
};
</script>
